import { useSearchParams } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminGrantsPanel } from '../components/AdminGrantsPanel';
import { grantSubjectFromParams } from '../lib/adminGrants';
import { SESSION_TOKEN } from '../lib/session';

// Entitlement grants route (epic #1259). Thin: <AdminGate/> keeps the panel (and
// its `/v1/admin/grants` reads + writes) behind the closed-beta staff wall.
// `token` is injectable for tests; the router mounts with no props.
//
// The WALL is not the fence. Staff sessions hold `admin:read:*` and can read a
// subject's grant history; issuing and revoking ride `admin:grants`, which no
// session carries, so each first asks the door for a one-hour operator credential
// (`createGrantActions`, #5709 / #5724). The door's own refusal (not platform
// staff, or sign in again) renders `<OperatorRefusalAlert/>`, and a write the API
// refuses shows its own 403 inline, rather than a control that silently was not
// there.
//
// The URL may ADDRESS the screen: `?subject_kind=user&subject_id=…` (the user
// registry's Grant link) opens it on that person. Parsed here, at the route,
// and handed down — the panel stays Router-free.

export function AdminGrants(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  const [params] = useSearchParams();
  return (
    <AdminGate token={token}>
      <AdminGrantsPanel token={token} initialSubject={grantSubjectFromParams(params)} />
    </AdminGate>
  );
}
